<template>
	<div>
		<div class="attend-card-wrapper px-4 pb-4 pt-7 mb-4" @click="handleClick">
			<div v-if='user.userFlag' :style='{backgroundColor: user.userFlag.flag_bg_color}'
				class="attend-card__user-flag">
				<span :style='{backgroundColor: user.userFlag.flag_bg_color, color: user.userFlag.flag_txt_color}'>
					{{user.userFlag.flag_name}}
					<span :style='{backgroundColor: user.userFlag.flag_bg_color}'></span>
				</span>
			</div>
			<Avatar class="mr-4 post-preview-card__avatar" size="85" :avatar="user.user_logo" />

			<div>
				<div class="attend-card-title">
					{{ user.visible_username }}
				</div>
				<div class="attend-card-description">
					{{ user.second_profile_row }}
				</div>
				<div class="attend-card-description">
					{{ user.third_profile_row }}
				</div>
				<div class="attend-card-loc d-flex align-center" v-if="user.location_profile_row">
					<Icon
						type='pin'
						color="var(--location-color)"
                        :size='16'
						:pr="4"
					/>
					{{ user.location_profile_row }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar'
import Dwh from '@/mixins/Dwh'

Vue.use(VueScrollTo)

export default {
	name: 'AttendCard',
	mixins: [Dwh],
	components: {
		Avatar,
	},
	props: {
		user: {
			type: Object,
			default: () => {},
		},
		event: {
			type: Object,
			default: () => {}
		}
	},
	methods: {
		handleClick() {
			this.sendTrigger({
				category: 'Content',
				action: 'click_attendee_profile_event',
				module: 'Events',
				data: this.user.user_id,
				content_chapter_id: this.event && this.event.chapter_id ? [this.event.chapter_id] : null
			})
		}
	}
}
</script>

<style lang="scss">
.attend-card {
	&-wrapper {
		display: flex;
		background: rgb(251, 251, 251);
		border: 1px solid rgb(226, 226, 226);
		border-radius: 12px;
		position: relative;
	}

	&-logo {
		width: 25%;
		object-fit: contain;
		margin-right: 10px;
	}
	&-title {
		color: var(--username-category-title);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: bold;

		@media (max-width: 480px) {
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;
		}
	}

	&-loc {
		display: flex;
		font-size: 13px;
		font-family: Montserrat;
		font-weight: 600;
		letter-spacing: 0px;
		line-height: 17px;
		color: var(--location-color) !important;
	}
	&-description {
		color: var(--company-position-large);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: normal;
		line-height: 20px;
	}
	&__user-flag {
		text-align: right;
		position: absolute;
		border-radius: 12px;
		top: 0;
		right: 0;

		span {
			z-index: 0;
			position: relative;
			background: var(--accent-color);
			display: inline-flex;
			padding: 5px 10px 5px 10px;
			border-top-right-radius: 8px;
			color: rgb(255, 255, 255);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
		}

		// Start
		span {
			span {
				z-index: -1;
				content: '';
				position: absolute;
				left: -17%;
				top: 0;
				height: 100%;
				width: 100%;
				-webkit-transform: skewX(20deg);
				-moz-transform: skewX(20deg);
				-ms-transform: skewX(20deg);
				transform: skewX(20deg);
			}
		}
	}
}
</style>
